import { render, staticRenderFns } from "./TriumphIcon.vue?vue&type=template&id=6545bce3&scoped=true&"
import script from "./TriumphIcon.vue?vue&type=script&lang=js&"
export * from "./TriumphIcon.vue?vue&type=script&lang=js&"
import style0 from "./TriumphIcon.vue?vue&type=style&index=0&id=6545bce3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6545bce3",
  null
  
)

export default component.exports